import { getAsset } from "../assets/assetManifest";

// The only way images are rendered. Dimensions come from the manifest so layout never shifts when art is swapped.
export const AssetImage = ({ id, className = "", style, width, height, ...rest }) => {
  const a = getAsset(id);
  const w = width ?? (height ? Math.round(height * a.aspectRatio) : undefined);
  const h = height ?? (width ? Math.round(width / a.aspectRatio) : undefined);
  return (
    <img
      src={a.path}
      alt={a.alt}
      width={w ?? a.width}
      height={h ?? a.height}
      data-asset-id={id}
      draggable={false}
      className={className}
      style={{ aspectRatio: `${a.width} / ${a.height}`, ...style }}
      {...rest}
    />
  );
};
